(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gl-allergietest"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('gl-allergy-dog')) {
  customElements.define('gl-allergy-dog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('[data-gallery-track]');
      const slides = [...this.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
      const previous = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      if (track && slides.length > 1) {
        let active = 0;
        let frame = 0;
        const select = (index) => {
          const target = Math.max(0, Math.min(slides.length - 1, index));
          track.scrollTo({left: target * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        const sync = () => {
          active = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
          thumbs.forEach((thumb, index) => {
            thumb.classList.toggle('is-active', index === active);
            if (index === active) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
          previous.disabled = active === 0;
          next.disabled = active === slides.length - 1;
        };
        thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => select(index)));
        previous.addEventListener('click', () => select(active - 1));
        next.addEventListener('click', () => select(active + 1));
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(sync);
        }, {passive: true});
        track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            select(active + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        sync();
      }
      const form = this.querySelector('form');
      const button = this.querySelector('button[name="add"]');
      const sticky = this.querySelector('[data-sticky]');
      const stickyButton = this.querySelector('[data-sticky-add]');
      const stickyVariant = this.querySelector('[data-sticky-variant]');
      const stickyPrice = this.querySelector('[data-sticky-price]');
      const observer = new IntersectionObserver((entries) => {
        sticky.hidden = entries[0].isIntersecting;
      }, {threshold: 0});
      observer.observe(button);
      this.stickyObserver = observer;

      const update = (writeUrl) => {
        const selected = form.querySelector('input[name="id"]:checked');
        if (!selected) return;
        this.querySelector('[data-price]').textContent = selected.dataset.money;
        button.disabled = selected.dataset.available !== 'true';
        stickyButton.disabled = button.disabled;
        stickyButton.textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
        stickyPrice.textContent = selected.dataset.money;
        stickyVariant.textContent = selected.dataset.title;

        this.querySelector('[data-button-label]').textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
        if (writeUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState(window.history.state, '', url);
        }
      };
      form.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"]')) update(true);
      });
      update(this.dataset.normalizeVariant === 'true');
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-discover-allergie"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const hero = root.querySelector('[data-hero-action]');
    const final = root.querySelector('[data-final-action]');
    const sticky = root.querySelector('[data-sticky-action]');
    if (!hero || !final || !sticky || !('IntersectionObserver' in window)) return;
    let passedHero = false;
    let atFinal = false;
    const heroObserver = new IntersectionObserver(entries => {
      passedHero = entries[0].boundingClientRect.bottom < 0;
      sticky.hidden = !passedHero || atFinal;
    });
    const finalObserver = new IntersectionObserver(entries => {
      atFinal = entries[0].isIntersecting;
      sticky.hidden = !passedHero || atFinal;
    });
    heroObserver.observe(hero);
    finalObserver.observe(final);
    root.addEventListener('gl:cleanup', () => { heroObserver.disconnect(); finalObserver.disconnect(); }, {once:true});
  }
  document.querySelectorAll('[data-gl-discovery]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => initialize(event.target.querySelector('[data-gl-discovery]')));
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('[data-gl-discovery]')?.dispatchEvent(new Event('gl:cleanup')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-dna-rasse"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('gl-dna-breed')) {
  customElements.define('gl-dna-breed', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('[data-gallery-track]');
      const slides = [...this.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
      const previous = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      if (track && slides.length > 1) {
        let active = 0;
        let frame = 0;
        const select = (index) => {
          const target = Math.max(0, Math.min(slides.length - 1, index));
          track.scrollTo({left: target * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        const sync = () => {
          active = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
          thumbs.forEach((thumb, index) => {
            thumb.classList.toggle('is-active', index === active);
            if (index === active) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
          previous.disabled = active === 0;
          next.disabled = active === slides.length - 1;
        };
        thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => select(index)));
        previous.addEventListener('click', () => select(active - 1));
        next.addEventListener('click', () => select(active + 1));
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(sync);
        }, {passive: true});
        track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            select(active + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        sync();
      }
      const form = this.querySelector('form');
      const button = this.querySelector('button[name="add"]');
      const sticky = this.querySelector('[data-sticky]');
      const stickyButton = this.querySelector('[data-sticky-add]');
      const stickyVariant = this.querySelector('[data-sticky-variant]');
      const stickyPrice = this.querySelector('[data-sticky-price]');
      const observer = new IntersectionObserver((entries) => {
        sticky.hidden = entries[0].isIntersecting;
      }, {threshold: 0});
      observer.observe(button);
      this.stickyObserver = observer;

      const update = (writeUrl) => {
        const selected = form.querySelector('input[name="id"]:checked');
        if (!selected) return;
        this.querySelector('[data-price]').textContent = selected.dataset.money;
        button.disabled = selected.dataset.available !== 'true';
        stickyButton.disabled = button.disabled;
        stickyButton.textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
        stickyPrice.textContent = selected.dataset.money;
        stickyVariant.textContent = selected.dataset.title;

        this.querySelector('[data-button-label]').textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
        if (writeUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState(window.history.state, '', url);
        }
      };
      form.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"]')) update(true);
      });
      update(false);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-erbkrankheiten"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('gl-hereditary-dog')) {
  customElements.define('gl-hereditary-dog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('[data-gallery-track]');
      const slides = [...this.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
      const previous = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      if (track && slides.length > 1) {
        let active = 0;
        let frame = 0;
        const select = (index) => {
          const target = Math.max(0, Math.min(slides.length - 1, index));
          track.scrollTo({left: target * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        const sync = () => {
          active = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
          thumbs.forEach((thumb, index) => {
            thumb.classList.toggle('is-active', index === active);
            if (index === active) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
          previous.disabled = active === 0;
          next.disabled = active === slides.length - 1;
        };
        thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => select(index)));
        previous.addEventListener('click', () => select(active - 1));
        next.addEventListener('click', () => select(active + 1));
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(sync);
        }, {passive: true});
        track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            select(active + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        sync();
      }
      const form = this.querySelector('form');
      const button = this.querySelector('button[name="add"]');
      const sticky = this.querySelector('[data-sticky]');
      const stickyButton = this.querySelector('[data-sticky-add]');
      const stickyVariant = this.querySelector('[data-sticky-variant]');
      const stickyPrice = this.querySelector('[data-sticky-price]');
      const observer = new IntersectionObserver((entries) => {
        sticky.hidden = entries[0].isIntersecting;
      }, {threshold: 0});
      observer.observe(button);
      this.stickyObserver = observer;

      const update = (writeUrl) => {
        const selected = form.querySelector('input[name="id"]:checked');
        if (!selected) return;
        this.querySelector('[data-price]').textContent = selected.dataset.money;
        button.disabled = selected.dataset.available !== 'true';
        stickyButton.disabled = button.disabled;
        stickyButton.textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
        stickyPrice.textContent = selected.dataset.money;
        stickyVariant.textContent = selected.dataset.title;

        this.querySelector('[data-button-label]').textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
        if (writeUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState(window.history.state, '', url);
        }
      };
      form.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"]')) update(true);
      });
      update(false);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-refresh-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = () => document.querySelectorAll('[data-gl-product]').forEach(root => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const price = root.querySelector('[data-gl-price]');
    const button = root.querySelector('[data-gl-add]');
    const variants = [...root.querySelectorAll('[data-gl-variant]')];
    const update = (input, changeUrl) => {
      if (!input) return;
      price.textContent = input.dataset.price;
      button.disabled = input.dataset.available !== 'true';
      button.textContent = button.disabled ? root.dataset.soldLabel : root.dataset.addLabel;
      if (changeUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState(window.history.state, '', url);
      }
    };
    variants.forEach(input => input.addEventListener('change', () => update(input, true)));
    const sync = () => {
      const id = new URL(window.location.href).searchParams.get('variant');
      const input = variants.find(item => item.value === id) || variants.find(item => item.checked);
      if (input) input.checked = true;
      update(input, false);
    };
    sync();
    window.addEventListener('pageshow', sync);
    window.addEventListener('popstate', sync);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
      theme.initUniformHeightMonitor(productRecommendationsSection, '.product-block__image-container', '.product-block__image-container .image-one');
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.destroyUniformHeightMonitor($('.product-recommendations', event.target));
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
